import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { ContentRestrictiveProps } from "./types";
import {
    PropertyDefinition,
    PropertyMappingType,
} from "app/library/layout-builder";

export class ContentRestrictiveDefinitions extends CmsReactComponent<ContentRestrictiveProps> {
    static schemaName = "content-restrictive";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "height",
            mapping: {
                type: PropertyMappingType.Number,
            },
            text: "Yükseklik",
            default: "200"
        }
    ];
}
